export default {
  title: 'In the News',
  items: [
    {
      title: 'The best, cheapest way to get good tech support',
      content:
        "You don't have to understand how an internal combustion engine works to drive your car to the mall, so why does it often feel like you need a degree in computer science just to use your PC?",
      image: `/_nextassets_/images/usa_today_logo.svg`,
      link: 'Read full article',
      href: 'http://www.usatoday.com/story/tech/columnist/saltzman/2017/01/21/tech-support-we-all-need-but-how-do-you-get/96783928/',
    },
    {
      title: "Succeeding With A 'Bolt-On Geek Squad'",
      content: "Richard Wolpert is not your average Silicon Valley startup CEO. For starters, he's in Los Angeles, not the Bay Area.",
      image: `/_nextassets_/images/fortune_logo.svg`,
      link: 'Read full article',
      href: 'http://fortune.com/2017/05/30/succeeding-with-a-bolt-on-geek-squad/',
    },
    {
      title: "Samsung's new Galaxy Note 8 customers get free in-home visits from HelloTech",
      content: 'For the launch of its new Galaxy Note 8 smartphone, Samsung is — not surprisingly — doubling down on the whole support thing.',
      image: `/_nextassets_/images/theverge_logo.svg`,
      link: 'Read full article',
      href: 'https://www.theverge.com/2017/8/23/16187814/samsung-galaxy-note-8-tech-support-hellotech',
    },
  ],
};
